export const BloodConfigActions = {
    UPDATE_YTOP : "UPDATE_YTOP",
    UPDATE_YBOTTOM : "UPDATE_YBOTTOM",
    UPDATE_WBC_COUNT : "UPDATE_WBC_COUNT",
    UPDATE_COUNT_SLOT_WISE: "UPDATE_COUNT_SLOT_WISE",
    RESET_CONFIG_SLOT_WISE: "RESET_CONFIG_SLOT_WISE", 
} 